// frontend/src/components/ContentUploader.js
import React, { useState } from 'react';
import api from '../api';
import { useAuth } from './AuthContext';

const ContentUploader = ({ courseId, onUploadComplete }) => {
  const { currentUser } = useAuth();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setError('');
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
  
    setIsUploading(true);
    setUploadProgress(0);
    const tempId = Date.now(); // ID temporal para el video
  
    try {
      const formData = new FormData();
      formData.append('video', selectedFile);
      formData.append('courseId', courseId);
      formData.append('title', selectedFile.name.replace(/\.[^/.]+$/, ""));
  
      const response = await api.post('/api/upload/videos', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(progress);
        }
      });
  
      // Actualiza el estado del video a "completado"
      setVideos(prev => prev.map(v => 
        v.id === tempId ? { ...v, status: 'completed' } : v
      ));
  
      if (onUploadComplete) {
        onUploadComplete([{
          ...response.data,
          id: tempId,
          status: 'completed'
        }]);
      }
    } catch (error) {
      console.error('Error al subir video:', error);
      setError('Error al subir el video. Por favor, inténtalo de nuevo.');
      // Marca el video como fallido
      setVideos(prev => prev.map(v => 
        v.id === tempId ? { ...v, status: 'failed' } : v
      ));
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-bold mb-4">Subir contenido</h2>
      
      <div className="space-y-4">
        <div>
          <label className="block text-gray-700 mb-2">Seleccionar video:</label>
          <input
            type="file"
            accept="video/*"
            onChange={handleFileChange}
            className="w-full px-4 py-2 border rounded"
            disabled={isUploading}
          />
        </div>

        {selectedFile && (
          <div className="text-sm text-gray-600">
            Archivo seleccionado: {selectedFile.name}
          </div>
        )}

        {error && (
          <div className="text-red-500 text-sm">{error}</div>
        )}

        {isUploading && (
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div
              className="bg-purple-600 h-2.5 rounded-full"
              style={{ width: `${uploadProgress}%` }}
            ></div>
          </div>
        )}

        <button
          onClick={handleUpload}
          disabled={!selectedFile || isUploading}
          className={`px-4 py-2 rounded text-white ${
            !selectedFile || isUploading
              ? 'bg-purple-400 cursor-not-allowed'
              : 'bg-purple-600 hover:bg-purple-700'
          }`}
        >
          {isUploading ? 'Subiendo...' : 'Subir Video'}
        </button>
      </div>
    </div>
  );
};

export default ContentUploader;